// extracted by mini-css-extract-plugin
export default {"Github":"Github_Github__zj1OX","GithubLogo":"Github_GithubLogo__9e1Q1","GithubText":"Github_GithubText__RzLH1"};